module.exports = __webpack_public_path__ + "img/micifr1.758dff9d.png";